import { TooltipData } from './CursorTooltip.types';
import { getTooltipMessage } from './tooltipHelpers';

interface ProcessElementConfig {
  updatePosition: (
    x: number,
    y: number,
  ) => { x: number; y: number; width: number } | null;
  showTooltip: (message: TooltipData, tooltipId: string | null) => void;
  hideTooltip: () => void;
}

export const processTooltipElement = (
  element: HTMLElement,
  clientX: number,
  clientY: number,
  config: ProcessElementConfig,
) => {
  const { updatePosition, showTooltip, hideTooltip } = config;

  const message = getTooltipMessage(element);
  const tooltipId = element.getAttribute('data-tooltip-id');

  if (!message) {
    hideTooltip();
    return;
  }

  const position = updatePosition(clientX, clientY);
  if (position) {
    showTooltip(message, tooltipId);
  } else {
    hideTooltip();
  }
};
